import { useTranslation } from "react-i18next";
import { withForm } from "@/components/form/form";
import { PageSection } from "@/components/section/SectionBlocks";
import { LabeledSelect } from "./LabeledSelect";
import { emptyModelValues } from "./modelForm";
import { COST_TIERS } from "./modelOptions";

/** Identity, limits and cost of a model. The id is only editable when creating. */
export const ModelBasicsFields = withForm({
  defaultValues: emptyModelValues(),
  props: { isNew: false },
  render: function ModelBasicsFieldsRender({ form, isNew }) {
    const { t } = useTranslation("adminModels");
    return (
      <PageSection title={t("form.basics.title")} description={t("form.basics.description")}>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {isNew && (
            <form.AppField name="id">
              {(field) => <field.TextField label={t("form.id")} required placeholder={t("form.idPlaceholder")} />}
            </form.AppField>
          )}
          <form.AppField name="name">
            {(field) => <field.TextField label={t("form.name")} required placeholder={t("form.namePlaceholder")} />}
          </form.AppField>
          <form.AppField name="deploymentName">
            {(field) => (
              <field.TextField
                label={t("form.deploymentName")}
                required
                placeholder={t("form.deploymentNamePlaceholder")}
              />
            )}
          </form.AppField>
          <form.Field name="costTier">
            {(field) => (
              <LabeledSelect
                label={t("form.costTier")}
                value={field.state.value}
                options={[
                  { value: "", label: t("form.costTierNone") },
                  ...COST_TIERS.map((tier) => ({ value: tier, label: tier })),
                ]}
                onChange={field.handleChange}
              />
            )}
          </form.Field>
          <form.AppField name="contextWindow">
            {(field) => <field.TextField label={t("form.contextWindow")} required />}
          </form.AppField>
          <form.AppField name="maxOutputTokens">
            {(field) => <field.TextField label={t("form.maxOutputTokens")} required />}
          </form.AppField>
          <form.AppField name="costPer1KInput">
            {(field) => <field.TextField label={t("form.costInput")} required />}
          </form.AppField>
          <form.AppField name="costPer1KOutput">
            {(field) => <field.TextField label={t("form.costOutput")} required />}
          </form.AppField>
        </div>
        <form.AppField name="description">
          {(field) => (
            <field.TextareaField
              label={t("form.description")}
              rows={2}
              placeholder={t("form.descriptionPlaceholder")}
            />
          )}
        </form.AppField>
        <form.AppField name="isEnabled">{(field) => <field.ToggleField label={t("form.enabled")} />}</form.AppField>
      </PageSection>
    );
  },
});
